import { Instance as axios, setHeaderWithImage, setToken } from "../instance";

// Customer onboarding (lead funnel) status + saved details
export const getOnboardingAPI = async () => {
  return axios.get(`api/onboarding`, setToken());
};

// Upload the signed contract (multipart, field "contract")
export const uploadOnboardingContractAPI = async (data) => {
  return axios.post(`api/onboarding/contract`, data, setHeaderWithImage());
};

// Propose own rates / TAT / charges: { proposed: { rates, stdTat, odaTat, charges }, reason }
export const createRateRequestAPI = async (data) => {
  return axios.post(`api/onboarding/rate-requests`, data, setToken());
};

// Pincode serviceability check (zone + ODA status)
export const searchServiceablePincodesAPI = async (params) => {
  const query = new URLSearchParams(
    Object.entries(params).filter(([, v]) => v !== "" && v != null)
  ).toString();
  return axios.get(`api/onboarding/pincodes?${query}`, setToken());
};

// ODA pincode sheet (xlsx blob)
export const exportOdaSheetAPI = async () => {
  return axios.get(`api/onboarding/oda-export`, { ...setToken(), responseType: "blob" });
};

// "My Contract": the master agreement filled with the customer's details and agreed rates
export const getContractAPI = async () => {
  return axios.get(`api/onboarding/contract`, setToken());
};

// Accept the standard contract with an email OTP
export const sendContractOtpAPI = async () => {
  return axios.post(`api/onboarding/contract/send-otp`, {}, setToken());
};

export const acceptContractByOtpAPI = async (otp) => {
  return axios.post(`api/onboarding/contract/accept`, { otp }, setToken());
};
